import React, { useState } from 'react';
import CashStatusContext from './index';

export const CashStatusProvider = ({ children }) => {
  const [cashStatus, setCashStatus] = useState(null);

  return (
    <CashStatusContext.Provider value={{ cashStatus, setCashStatus }}>
      {children}
    </CashStatusContext.Provider>
  );
};